import { ClientT } from '../../types/Users';
import { ActionT, LOG_OUT } from '../actions/actionsType';

export const FILTERS_JOBS_REST = "FILTERS_JOBS_REST"
export const FILTERS_JOBS_SAVE = "FILTERS_JOBS_SAVE"

export interface FiltersStateT {
    startDate: string
    endDate: string
    jobStatus: Array<string>
    jobType: Array<string>
    client: ClientT | null
}

export const InitFiltersJobs: FiltersStateT = {
    startDate: "",
    endDate: "",
    jobStatus: [],
    jobType: [],
    client: null,
}


export function filtersJobs(state: FiltersStateT = InitFiltersJobs, action: ActionT): FiltersStateT {
    switch (action.type) {
        case FILTERS_JOBS_SAVE:
            return { ...state, ...action.payload };
        case FILTERS_JOBS_REST:
            return {
                ...state,
                ...InitFiltersJobs
            }
        case LOG_OUT:
            return {
                ...state,
                ...InitFiltersJobs
            }
        default:
            return state;
    }
}
